import React, { useMemo } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { I18nMessages } from "../../../../../../../i18n/i18n";
import { style as photosDescriptionStyle } from "./PhotosDescription.style";
const PhotosDescription = ({ domain, segment, i18nPrefix }) => {
    const description = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.YOU_PHOTOS_SUBTITLE,
        values: { segment: segment.toLowerCase() },
    });
    const style = useMemo(() => photosDescriptionStyle(), []);
    return (React.createElement(Text, { level: 3, style: style.description }, description));
};
export { PhotosDescription };
